module.exports = __webpack_public_path__ + "static/haccp-76875a249126297f00366594be924ae8.png";